<div class="flex-column text-center">
    <h2>SADEY UG</h2>
    Alt-Stralau 52<br> D-10245 Berlin<br> Geschäftsführung: Leona Gieske <br> T +49 (0) 172 4362713<br>
    <!-- F +49 (0) 52 21. 28 10 23<br> -->
    E-mail: hello@sadey.de<br><br> Eintragung im Handelsregister. Registergericht: AG Charlottenburg | Registernummer: HRB 222616 B | StNr: 37/502/50431
</div>